/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tickets: NonNullable<unknown>, pudos: NonNullable<unknown> }} Colleague_Map_LegendInputs */

const en_colleague_map_legend = /** @type {(inputs: Colleague_Map_LegendInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tickets} tickets · ${i?.pudos} depots`)
};

const ja_colleague_map_legend = /** @type {(inputs: Colleague_Map_LegendInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`チケット ${i?.tickets} 件 · 拠点 ${i?.pudos} 件`)
};

const fr_colleague_map_legend = /** @type {(inputs: Colleague_Map_LegendInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tickets} tickets · ${i?.pudos} dépôts`)
};

const de_colleague_map_legend = /** @type {(inputs: Colleague_Map_LegendInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tickets} Tickets · ${i?.pudos} Depots`)
};

/**
* | output |
* | --- |
* | "{tickets} tickets · {pudos} depots" |
*
* @param {Colleague_Map_LegendInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_map_legend = /** @type {((inputs: Colleague_Map_LegendInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_Map_LegendInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_map_legend(inputs)
	if (locale === "ja") return ja_colleague_map_legend(inputs)
	if (locale === "fr") return fr_colleague_map_legend(inputs)
	return de_colleague_map_legend(inputs)
});